// extracted by mini-css-extract-plugin
export default {"subtitle":"quiz_subtitle__GZuYb","mainTitle":"quiz_mainTitle__W75I4"};